import { AdminApp } from '../admin/AdminApp';
import { siteIdentity } from '../content/siteContent';
import { BlogPage } from '../public/pages/BlogPage';
import { CatalogItemPage } from '../public/pages/CatalogItemPage';
import { CatalogPage } from '../public/pages/CatalogPage';
import { ContactPage } from '../public/pages/ContactPage';
import { CuratedPage } from '../public/pages/CuratedPage';
import { CustomPageRoute } from '../public/pages/CustomPage';
import { GalleryPage } from '../public/pages/GalleryPage';
import { HomePage } from '../public/pages/HomePage';
import { NotFoundPage } from '../public/pages/NotFoundPage';
import { PostPage } from '../public/pages/PostPage';

export function CurrentRoute() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const tail = (prefix: string) => decodeURIComponent(path.slice(prefix.length));

  if (path === '/') return <HomePage />;
  if (path === '/about') return <CuratedPage slug="about" />;
  if (path === '/gallery') return <GalleryPage />;
  if (path === '/contact') return <ContactPage />;
  if (path === siteIdentity.catalogPath) return <CatalogPage />;
  if (path.startsWith(`${siteIdentity.catalogPath}/`)) return <CatalogItemPage slug={tail(`${siteIdentity.catalogPath}/`)} />;
  if (path === '/blog') return <BlogPage />;
  if (path.startsWith('/blog/')) return <PostPage slug={tail('/blog/')} />;
  if (path.startsWith('/pages/')) return <CustomPageRoute slug={tail('/pages/')} />;
  if (path === '/admin' || path.startsWith('/admin/')) return <AdminApp />;

  return <NotFoundPage />;
}
